import classNames from "classnames";
import { RefObject } from "react";

import { useBreakpoint } from "@/utils/breakpoints/breakpoints.provider";

import { StoreSearchControls } from "./components/controls/storeSearchControls.container";
import { StoreSearchListComponent } from "./components/list/storeSearchList.component";
import { StoreSearchMapContainer } from "./components/map/storeSearchMap.container";
import { useStoreSearchContext } from "./storeSearch.context";

type StoreSearchComponentProps = {
    mapElementRef: RefObject<HTMLDivElement | null>;
};

const StoreSearchComponent = ({ mapElementRef }: StoreSearchComponentProps) => {
    const { breakpoints } = useBreakpoint();

    const { tab } = useStoreSearchContext();

    return breakpoints.md ? (
        <article className={"store-search store-search--md"}>
            <section className={"store-search__list"}>
                <StoreSearchControls />
                <StoreSearchListComponent />
            </section>
            <section className={"store-search--md__map"}>
                <StoreSearchMapContainer ref={mapElementRef} />
            </section>
        </article>
    ) : (
        <article className={"store-search store-search--sm"}>
            <StoreSearchControls />
            <div
                className={classNames("store-search__tabs", {
                    "store-search__tabs--list-active": tab === "list",
                    "store-search__tabs--map-active": tab === "map"
                })}
            >
                <section className={"store-search__tab store-search__list"}>
                    <StoreSearchListComponent />
                </section>
                <section className={"store-search__tab"}>
                    <StoreSearchMapContainer ref={mapElementRef} />
                </section>
            </div>
        </article>
    );
};

export { StoreSearchComponent };
